import Vue from 'vue'
import Editor from '@/components/utils/TextEditor/Index.vue'

Vue.component('nt-editor', Editor)
